import React, { useState } from "react";
import "../CSS/About.css";

function About() {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="about-background">
      <div className="about-page">
        <h1 className="about-title">About AmphiGreen</h1>

        <div className="about-tabs">
          <button
            className={activeTab === "overview" ? "active" : ""}
            onClick={() => setActiveTab("overview")}
          >
            Overview
          </button>
          <button
            className={activeTab === "vision" ? "active" : ""}
            onClick={() => setActiveTab("vision")}
          >
            Vision & Mission
          </button>
          <button
            className={activeTab === "differentiators" ? "active" : ""}
            onClick={() => setActiveTab("differentiators")}
          >
            Our Differentiators
          </button>
        </div>

        <div className="about-content fade-in">
          {activeTab === "overview" && (
            <>
              <h2>Overview of AmphiGreen</h2>
              <p>
                AGSPL, a transformation from Amphi Analytic (established in 2009
                as a tax consultancy company), is now a pioneering name in
                climate finance, sustainable energy, and green infrastructure
                solutions.
              </p>
              <p>
                As the global renewable energy industry evolves rapidly —
                shaped by new technologies, business models, and ecosystems —
                opportunities grow, but so do the complexities, creating
                uncertainty, risks, and delays.
              </p>
              <p>
                For organizations transitioning to green energy, the ability to
                move quickly and decisively is essential. AGSPL, with over a
                decade of excellence and trusted expertise, empowers clients to
                take agile, confident steps toward sustainability.
              </p>

              <ul>
                <li>Plan the right long-term strategy for renewable transition</li>
                <li>Design effective market entry strategies that mitigate risks</li>
                <li>Improve financing and tax structures</li>
                <li>
                  Scale up businesses with innovative technologies to accelerate
                  decarbonization
                </li>
                <li>
                  Achieve carbon-neutral or carbon-negative targets through
                  innovation
                </li>
                <li>Meet stakeholder expectations for clean energy leadership</li>
              </ul>
            </>
          )}

          {activeTab === "vision" && (
            <>
              <h2>Vision & Mission</h2>
              <p>
                Our vision is to lead the transition towards a sustainable and
                carbon-neutral future through innovation, collaboration, and
                expertise.
              </p>
              <p>
                We are driven by the mission to empower businesses, governments,
                and communities to adopt green solutions that preserve resources,
                improve efficiency, and promote environmental responsibility.
              </p>

              <ul>
                <li>Foster clean energy adoption at every scale</li>
                <li>Promote climate resilience through sustainable solutions</li>
                <li>Encourage green innovation for long-term impact</li>
                <li>Support carbon offset and renewable financing initiatives</li>
              </ul>
            </>
          )}

          {activeTab === "differentiators" && (
            <>
              <h2>Our Differentiators</h2>
              <p>
                What sets AmphiGreen apart is our deep integration of technology,
                domain knowledge, and purpose-driven sustainability.
              </p>

              <ul>
                <li>Over a decade of proven expertise in green finance</li>
                <li>Customized renewable transition strategies</li>
                <li>Data-driven sustainability assessments</li>
                <li>Strong partnerships with global clean-tech innovators</li>
                <li>Commitment to transparency and measurable outcomes</li>
                <li>Focus on both environmental and economic balance</li>
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default About;
